export default "__VITE_ASSET__86389dfd__"